import * as React from "react";
import { Header, List, Segment } from "semantic-ui-react";

export default function FeaturesSection() {
  return (
    <>
      <Header as="h1">Features</Header>
      <Segment style={{ padding: "0em 4em" }} vertical>
        <List size="large" ordered>
          <List.Item>
            <List.Header>
              Merge objects with high volume and good performance concern
            </List.Header>
          </List.Item>
          <List.Item>
            <List.Header>Support high volume</List.Header>Object.assign merging
            100000 items on Safari throw exception :/
          </List.Item>
          <List.Item>
            <List.Header>High Performance</List.Header>Lazy picking value
            instead of really merging all objects
          </List.Item>
          <List.Item>
            <List.Header>Low Memory Usage</List.Header>Alway reuse same instance
            data structure instead of creating new every time
          </List.Item>
          <List.Item>
            <List.Header>Lazy Process and Interactive</List.Header>Perform merge
            only when you need the result, not doing unnecessary processing,
            Accumulator can be manipulated before/after merge
          </List.Item>
          <List.Item>
            <List.Header>Unit tested with high coverage (>90%)</List.Header>
          </List.Item>
          <List.Item>
            <List.Header>
              Support major browsers on desktop and mobile including IE 11
            </List.Header>
          </List.Item>
          <List.Item>
            <List.Header>
              Lightweight and without external dependencies
            </List.Header>
            ~1KB minzipped
          </List.Item>
        </List>
      </Segment>
    </>
  );
}
